module.exports = __webpack_public_path__ + "static/media/pf.2a69c581.svg";